module.exports = __webpack_public_path__ + "static/media/bayar.39fa4147.svg";